import React from 'react'
import { useRouteMatch, Switch, Route, Redirect } from 'react-router-dom'
import { useLocation } from 'react-router-dom/cjs/react-router-dom'
import _ from 'lodash'
import CompanyDetail from './CompanyDetail'
import SitesTabs from './SitesTabs'

const Company = () => {
  let match = useRouteMatch()
  let params = useRouteMatch('/facilities/details/:companyId')
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const companybranchId = queryParams.get('companybranchId')

  return (
    <div>
      <Switch>
        <Route exact path={`${match.path}/details/:companyId`}>
          <CompanyDetail companybranchId={companybranchId} companyId={_.get(params, ['params', 'companyId'])} />
        </Route>
        <Route exact path={match.path}>
          <SitesTabs />
        </Route>
        <Redirect to={match.path} />
      </Switch>
    </div>
  )
}

export default Company
